import React from 'react';
import PropTypes from 'prop-types';
import { Toggler } from '~/platform/utilities/feature-toggles';

const ToggleWrapper = ({
  toggleKey,
  displayWhenDisabled = false,
  children,
}) => {
  if (React.Children.count(children) === 0) return null;

  return toggleKey ? (
    <Toggler toggleName={Toggler.TOGGLE_NAMES[toggleKey]}>
      {!displayWhenDisabled ? (
        <Toggler.Enabled>{children}</Toggler.Enabled>
      ) : (
        <Toggler.Disabled>{children}</Toggler.Disabled>
      )}
    </Toggler>
  ) : (
    children
  );
};

ToggleWrapper.propTypes = {
  children: PropTypes.object,
  displayWhenDisabled: PropTypes.bool,
  toggleKey: PropTypes.string,
};

export default ToggleWrapper;
